export interface WorkflowFeedbackValue {
  tone: "error" | "success";
  message: string;
}

export { responseError } from "@/lib/api-error";

export function TripWorkflowFeedback({
  value,
}: {
  value: WorkflowFeedbackValue | null;
}) {
  if (!value) return null;
  return (
    <div
      role={value.tone === "error" ? "alert" : "status"}
      className={
        value.tone === "error"
          ? "rounded-md border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-800"
          : "rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs text-emerald-800"
      }
    >
      {value.message}
    </div>
  );
}
